import { render, staticRenderFns } from "./PushPartnerTariff.vue?vue&type=template&id=1a319413&"
import script from "./PushPartnerTariff.vue?vue&type=script&lang=ts&"
export * from "./PushPartnerTariff.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports